export const setToken = (token: string) =>
  localStorage.setItem('_token', token);

export const getToken = () => localStorage.getItem('_token');

export const removeToken = () => localStorage.removeItem('_token');

export const clearStorage = () => localStorage.clear();
